const HC_URL_BY_LOCALE = {
  en: '/en-US',
  fr: '/fr-fr',
}

class IframeObserver {
  constructor ({ id, callback }) {
    this.id = id
    this.callback = callback
    this.observer = null
  }

  connected () {
    this.checkForIframe()

    this.observer = new MutationObserver(() => {
      this.checkForIframe()
    })

    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
    })
  }

  disconnected () {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  checkForIframe () {
    const iframe = document.getElementById(this.id)

    if (!iframe || iframe.__iframeObserved) {
      return
    }

    iframe.__iframeObserved = true

    const handleLoad = () => {
      this.callback(iframe)
    }

    if (
      iframe.contentWindow &&
      iframe.contentDocument?.readyState === 'complete'
    ) {
      handleLoad()
      return
    }

    iframe.addEventListener('load', handleLoad, { once: true })
  }
}
class HelpCenterLocale extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.syncHcUrl()

    this.loader = this.els.loader?.element
    this.delay = Number(this.dataset.delay) || 300

    const uid = this.dataset.uid

    const iframeObserver = new IframeObserver({
      id: uid,
      callback: this.updateUI.bind(this),
    })

    iframeObserver.connected()
  }

  updateUI (iframe) {
    window.setTimeout(() => {
      iframe.setAttribute('aria-hidden', false)
      this.loader.setAttribute('aria-hidden', true)
    }, this.delay)
  }

  syncHcUrl () {
    const expected = HC_URL_BY_LOCALE[this.dataset.locale]
    if (!expected) return

    const url = new URL(window.location.href)
    if (url.searchParams.get('hcUrl') === expected) return

    url.searchParams.set('hcUrl', expected)
    window.location.replace(url.toString())
  }
}

if (!window.customElements.get('help-center-locale')) {
  window.customElements.define('help-center-locale', HelpCenterLocale)
}
